module.exports = __webpack_public_path__ + "img/609315944.cf8ccd74.jpg";